import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

import LocationsList from './components/LocationsList/LocationsList';

import { LocationsWrapper, MainWrapper } from './styles';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { getRequest } from '../../../../api/api';
import FilterInput from '../../../../commonComponents/FilterInput/FilterInput';
import StackHorizontal from '../../../StackHorizontal/StackHorizontal';

export const LocationsModal = ({ closeModal }) => {
    const {
        storeUrls: { PROJECT_LOCATIONS_URL },
        token,
    } = useSelector((state) => state.generalReducer);
    const [filteredProjectsList, setFilteredProjectsList] = useState([]);

    const updateFilteredArray = (filteredArray) => {
        setFilteredProjectsList(filteredArray);
    };

    const { data: locations, isFetching } = useQuery({
        queryKey: ['allLocations'],
        queryFn: async () => {
            const res = await getRequest(PROJECT_LOCATIONS_URL.url, token);
            return res;
        },
        staleTime: 15 * 60 * 1000,
    });

    const allLocations = locations || [];

    const styles = {
        minHeight: 400,
        minWidth: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    if (isFetching) {
        return (
            <div style={styles}>
                <Spinner size={3} />
            </div>
        );
    }

    return (
        <MainWrapper>
            <StackHorizontal>
                <FilterInput
                    inputArray={allLocations}
                    updateFilteredArray={updateFilteredArray}
                    matchFields={['name', 'id']}
                />
            </StackHorizontal>

            <LocationsWrapper>
                <LocationsList list={filteredProjectsList} onBeforeNavigate={closeModal} />
            </LocationsWrapper>
        </MainWrapper>
    );
};
